const en: Record<string, string> = {
  'dashboard.title': 'Dashboard',
  'dashboard.tabs.tasks': 'Tasks',
  'dashboard.tabs.tribes': 'Tribes',
  'dashboard.tabs.bookmarks': 'Bookmarks',
  'dashboard.tabs.planning': 'Planning',
  'dashboard.tabs.projects': 'Projects',
  'dashboard.tabs.taskInstances': 'Tasks',
  'dashboard.tabs.eventInstances': 'Events',

  'dashboard.planning.noEvents': 'No events on this day.',
  'dashboard.planning.noTasks': 'No tasks due today.',
  'dashboard.planning.tasksDue': 'Tasks due',

  'tabConfig.configure': 'Configure tabs',
  'tabConfig.finishConfigure': 'Done',
  'tabConfig.tab': 'Tab',
  'tabConfig.visible': 'Visible',
  'tabConfig.default': 'Default',
  'tabConfig.order': 'Order',
  'tabConfig.moveUp': 'Move up',
  'tabConfig.moveDown': 'Move down',
  'tabConfig.toggleVisibility': 'Toggle visibility',
  'tabConfig.setDefault': 'Set as default tab',
  'tabConfig.icon': 'Icon',
  'tabConfig.color': 'Color',
  'tabConfig.name': 'Name',
  'tabConfig.hideName': 'Hide the name (icon only)',
  'tabConfig.showName': 'Show the name',
  'tabConfig.setIconFirst': 'Choose an icon first',

  'features.addFeature': 'Add Feature',
  'features.feature': 'Feature',
  'features.remove': 'Remove',
  'features.featureType': 'Feature Type',
  'features.selectType': 'Select a type...',
  'features.featureName': 'Name',
  'features.featureNamePlaceholder': 'e.g. Sprint backlog',
  'features.featureIcon': 'Icon (optional if a name is set)',
  'features.rename': 'Rename feature',
  'features.archive': 'Archive feature',
  'features.archiveTitle': 'Archive this feature?',
  'features.archiveMessage':
    'This will archive "{{name}}". It will no longer be visible.',
  'features.unknownType': 'Unknown feature type: {{type}}',

  'admin.features': 'Features',
  'admin.features.type': 'Feature type',
  'admin.features.allTypes': 'All types',
  'admin.features.restore': 'Restore',
  'admin.features.restoreTitle': 'Restore this feature?',
  'admin.features.restoreMessage':
    '"{{name}}" will become visible again in the project.',
  'admin.features.selectProject': 'Select a project to manage its features',

  'dashboard.quickAdd.addTask': 'Add task',
  'dashboard.quickAdd.project': 'Project',
  'dashboard.quickAdd.selectProject': 'Select a project...',
  'dashboard.quickAdd.featureInstance': 'Tab',
  'dashboard.quickAdd.selectInstance': 'Select a tab...',
  'dashboard.quickAdd.noInstanceOfType': 'No compatible tab found.',
  'dashboard.quickAdd.selectFeature': 'Select a tab',
  'dashboard.quickAdd.changeFeature': 'Change',
  'dashboard.quickAdd.taskTitlePlaceholder': 'Task title...',
  'dashboard.quickAdd.create': 'Create',

  'dashboard.quickAddDefaults.menuLabel': 'Quick-add defaults',
  'dashboard.quickAddDefaults.title': 'Quick-add defaults',
  'dashboard.quickAddDefaults.task': 'Task',
  'dashboard.quickAddDefaults.event': 'Event',
  'dashboard.quickAddDefaults.none': 'None (ask each time)',
  'dashboard.quickAddDefaults.selectTribe': 'Select a tribe...',
  'dashboard.quickAddDefaults.selectProject': 'Select a project...',
  'dashboard.quickAddDefaults.selectInstance': 'Select a tab...',
  'dashboard.quickAddDefaults.change': 'Change',
  'dashboard.quickAddDefaults.clear': 'Clear',

  'dashboard.directory.openTasks': 'open tasks',
  'dashboard.directory.upcomingEvents': 'upcoming events',
  'dashboard.directory.kanbanBoard': 'Kanban board',
  'dashboard.directory.todoList': 'Todo list',
  'dashboard.directory.eventCalendar': 'Event calendar',
  'dashboard.directory.noProjects': 'No accessible projects yet.',
  'dashboard.directory.noTaskInstances': 'No accessible task boards or lists yet.',
  'dashboard.directory.noEventInstances': 'No accessible event calendars yet.',
  'dashboard.directory.noFilterMatches': 'No results for the selected tribes.',

  'dashboard.pinnedTab.pin': 'Pin as tab',
  'dashboard.pinnedTab.unpin': 'Unpin tab',
  'dashboard.pinnedTab.unavailable': 'This feature is no longer available. You can unpin this tab.',
};

export default en;
